import React, { Component } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Growl } from "primereact/growl";
import { Dialog } from "primereact/dialog";
import { Message } from "primereact/message";
import servicioObjetos from '../servicio/ServicioObjetos';
import servicioHttp from "../servicio/ServicioHttp";
import { Paginator } from 'primereact/paginator';
import servicioFormatos from '../servicio/ServicioFormatos';
import { DEFAULT_MASKS } from '../servicio/ServicioConstantes';
export class TablaTopeSGDF extends Component {
    constructor() {
        super();
        this.state = {
            desarrollador:false,
            mostrarModalConfirmacion:false,
            tope: {},
            mostrarModalTope: false,
            errores: {},
            idsenube: 0,
            paginacion: {
                registrosPorPagina: 10,
                registrosTotales: 0,
                join: null,
                restriccionesDinamicas: [
                ]
            },
        }

    }
    asignarValores = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    }
    mostrarModalTope = () => {
        this.setState({ mostrarModalTope: true, tope:{} });
    }
    preEditar = (rowData) => {
        let tope = JSON.parse(JSON.stringify(rowData));
        this.setState({ tope: tope, mostrarModalTope: true });

    }
    cerrarModal = () => {
        this.setState({ mostrarModalTope: false });
    }
    guardarTope = () => {
        let { tope } = this.state;
        servicioHttp.consumirPostHttp('tope_sgdf/guardar.json', tope).then(response => {
            this.setState({ mostrarModalTope: false, tope: {} })
            this.obtenerResultados();
            this.growl.show({ severity: 'success', summary: 'Aviso', detail: response.data.mensaje, life: 6000 });
        }).catch(error => {
            this.growl.show({ severity: 'error', summary: 'Error', detail: "No se guardo la información", life: 6000 });
        });

    }

    componentDidMount() {
        this.obtenerResultados();
        this.obtnerUsuarioDesarrollador();
    }
    obtnerUsuarioDesarrollador =() =>{
       servicioHttp.consumirPostHttp('usuario/obtener_usuario_sesion_perfil.json').then(response => {
           if(response.data.mensaje==="existe"){
              this.setState({desarrollador:true}); 
           }
        }).catch(error => {
        });
       }
    asignar_restricciones = () => {
        let { paginacion } = this.state;
        paginacion.restriccionesDinamicas = [];
    }
    obtenerResultados = () => {
        let { paginacion } = this.state;
        servicioHttp.consumirPostHttp('tope_sgdf/consultar.json', paginacion).then(response => {
            this.setState({ paginacion: response.data.objeto })
        }).catch(error => {

        });
    }
    cambiaPagina = (event) => {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first, paginacion });
        this.obtenerResultados();
    }
    columnaFecha = (rowData, column) => {
        return <div>{servicioFormatos.formatearFecha(rowData.fechaVigente)}</div>;
    }
    prepararEditar = (rowData) =>{
        let tope = JSON.parse(JSON.stringify(rowData));
        this.setState({tope: tope, mostrarModalTope:true});
      }
    plantillaOpciones = (rowData, column) => {
        let{desarrollador} = this.state;
        return <div className="p-grid">
            <div className="p-col-12 p-md-6">
            {desarrollador ?
                <Button type="button" icon="pi-md-edit" onClick={(e) => this.prepararEditar(rowData)}
                    className="p-button-warning" name="editar" tooltip="Editar">
                </Button>
                :null}
            </div>
            <div className="p-col-12 p-md-6">
            {desarrollador ?
                <Button type="button" icon="pi-md-delete" onClick={(e) => this.mostrarModalEliminar(rowData)}
                    className="p-button-danger" name="eliminar" tooltip="Eliminar">
                </Button>
                :null}
            </div>
     </div>;
    }
    mostrarModalEliminar = (rowData) =>{
        let tope = JSON.parse(JSON.stringify(rowData));
        this.setState({ tope: tope, mostrarModalConfirmacion: true });
    }
    eliminar = () => {
        let {tope} = this.state;
        servicioHttp.consumirPostHttp('tope_sgdf/eliminar.json', tope).then(response => {
            this.setState({ mostrarModalActualizarPatron: false, tope: {}, mostrarModalConfirmacion: false })
            this.obtenerResultados();
            this.growl.show({ severity: 'success', summary: 'Aviso', detail: response.data.mensaje, life: 6000 });
        }).catch(error => {
            this.growl.show({ severity: 'error', summary: 'Error', detail: "No se elimino el patron", life: 6000 });
        });
    }
    render() {
        let { desarrollador, paginacion, idsenube, tope, errores, mostrarModalTope } = this.state;
        let pieTablaBotones = <div className="p-fluid p-grid">
            <div className="p-col-12 p-md-2">
                {desarrollador ?
              <Button className="p-button-secondary" type="button"  name="agregarEjercicio" label="Agregar Ejercicio" tooltip="Agregar Ejercicio" onClick={this.mostrarModalTope}></Button> 
            : null}
              </div>
        </div>;
       
        const pieDialogoTope = (
            <div>
                <Button icon="pi-md-check" label="Aceptar" onClick={this.guardarTope} />
                <Button icon="pi-md-close" label="Cancelar" onClick={this.cerrarModal} className="p-button-danger flat-btn" />
            </div>
        );
        const dialogFooterConfirmacionEliminar = (
            <div>
               
                <Button
                    icon="pi-md-check"
                    onClick={this.eliminar}
                    label="Si estoy seguro"
                />
              
               
                <Button
                    icon="pi-md-close"
                    onClick={() =>
                        this.setState({
                            tope: {},
                            mostrarModalConfirmacion: false,
                            errores: {},
                        })
                    }
                    label="No estoy seguro"
                    className="p-button-danger flat-btn"
                />
              
            </div>
        );
        return (
            <div className="p-fluid">
                <Growl ref={(el) => this.growl = el} />
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <h1>TABLA TOPE SGDF</h1>
                        </div>
                    </div>
                </div>
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <DataTable footer={pieTablaBotones}  value={paginacion.datos} header="TABLA TOPE SGDF" responsive={true} resizableColumns={true} >
                                <Column field="anio" header="AÑO" style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="uma" header="UMA" style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="uma3" header="3 UMA" style={{ width: '120px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="uma25" header="25 UMA" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                               {desarrollador ? <Column body={this.plantillaOpciones} header="OPCIONES" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />:null}
                            </DataTable>
                            <Paginator first={idsenube} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                        </div>
                    </div>
                    <Dialog appendTo={document.body} header="Actualizar Tabla Tope SGDF" visible={mostrarModalTope}
                        modal={true} onHide={this.cerrarModal} footer={pieDialogoTope}>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-3">
                                <label htmlFor="tope.anio"><strong>Año:</strong></label>
                            </div>

                            <div className="p-col-12 p-md-2">
                                <InputText  keyfilter={DEFAULT_MASKS.money} type="text" id="tope.anio" name="tope.anio"
                                    value={tope.anio || ""} className={errores.anio ? "p-error" : ""}
                                    onChange={(e) => { this.asignarValores(e, false) }} />
                                {errores.anio ? <Message severity="error" text={errores.anio} /> : null}
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label htmlFor="tope.uma"><strong>UMA:</strong></label>
                            </div>
                            <div className="p-col-12 p-md-2">
                                <InputText  keyfilter={DEFAULT_MASKS.money} type="text" id="tope.uma" name="tope.uma"
                                    value={tope.uma || ""} className={errores.uma ? "p-error" : ""}
                                    onChange={(e) => { this.asignarValores(e, false) }} />
                                {errores.uma ? <Message severity="error" text={errores.uma} /> : null}
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label htmlFor="tope.uma3"><strong>UMA 3:</strong></label>
                            </div>
                            <div className="p-col-12 p-md-2">
                                <InputText  keyfilter={DEFAULT_MASKS.money} type="text" id="tope.uma3" name="tope.uma3"
                                    value={tope.uma3 || ""} className={errores.uma3 ? "p-error" : ""}
                                    onChange={(e) => { this.asignarValores(e, false) }} />
                                {errores.uma3 ? <Message severity="error" text={errores.uma3} /> : null}
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label htmlFor="tope.uma25"><strong>UMA 25:</strong></label>
                            </div>
                            <div className="p-col-12 p-md-2">
                                <InputText  keyfilter={DEFAULT_MASKS.money} type="text" id="tope.uma25" name="tope.uma25"
                                    value={tope.uma25 || ""} className={errores.uma25 ? "p-error" : ""}
                                    onChange={(e) => { this.asignarValores(e, false) }} />
                                {errores.uma25 ? <Message severity="error" text={errores.uma25} /> : null}
                            </div>
                        </div>
                    </Dialog>
                    <Dialog
                            header="Confirmación"
                            visible={this.state.mostrarModalConfirmacion}
                            modal={true}
                            style={{ width: "30vw" }}
                            footer={dialogFooterConfirmacionEliminar}
                            onHide={() =>
                                this.setState({
                                    cliente: {},
                                    mostrarModalConfirmacion: false,
                                    errores: {},
                                })
                            }
                        >
                            <h2>¿Estás seguro de eliminar la información?</h2>
                        </Dialog>
                </div>
            </div>
        );
    }
}